import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'roo-ui/components';
import { differenceInCalendarDays } from 'lib/date';
import pluralize from 'pluralize';

const NumberOfNights = ({ checkIn, checkOut, ...rest }) => {
  const totalDays = differenceInCalendarDays(checkOut, checkIn);
  return (
    <Text data-testid="numberOfNights" {...rest}>
      {pluralize('night', totalDays, true)}
    </Text>
  );
};

NumberOfNights.propTypes = {
  checkIn: PropTypes.instanceOf(Date).isRequired,
  checkOut: PropTypes.instanceOf(Date).isRequired,
};

export default NumberOfNights;
